import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useWorkTimeMatterSelect } from './useWorkTimeMatterSelect';

interface WorkTimeMatterSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the matter list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const WorkTimeMatterSelect = ({ onOpenPicker, onClear }: Readonly<WorkTimeMatterSelectProps>) => {
  const { t } = useTranslation();
  const select = useWorkTimeMatterSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('matter:matter')}
      placeholder={t('matter:selectMatter')}
      searchPlaceholder={t('matter:search')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="matter"
      data-testid="worktime-matter-select-button"
    />
  );
};

export default WorkTimeMatterSelect;
